var _a, _b, _c;
import { config } from "@frameworks/web/config/domain";
export var EServiceRequest;
(function (EServiceRequest) {
    EServiceRequest["EMAILPHONE"] = "Email and Phone Update";
    EServiceRequest["BANK"] = "Bank Modification";
    EServiceRequest["ADDRESS"] = "Change of Address";
    EServiceRequest["CKYC"] = "CKYC Update";
    EServiceRequest["FATCA"] = "FATCA Declaration";
    EServiceRequest["REACTIVATION"] = "Equity Dormant Reactivation";
    EServiceRequest["ACCOUNT_CLOSURE"] = "Online Closure";
    EServiceRequest["NOMINATION"] = "Nomination";
    EServiceRequest["DDPI"] = "Online DDPI";
    EServiceRequest["INCOME_DECLARATION"] = "Income Declaration";
    EServiceRequest["DP_SCEHEME"] = "DP Scheme Change";
    EServiceRequest["DIS_BOOKLET"] = "New DIS Booklet";
    EServiceRequest["SMTF"] = "NRML-SMTF Funds Movement Preference";
    EServiceRequest["SEGMENT_ACTIVATION"] = "Segment Activation";
})(EServiceRequest || (EServiceRequest = {}));
export var SRStatusMapping = (_a = {},
    _a[EServiceRequest.EMAILPHONE] = {
        None: { badge: "orange_bdg", value: "Esign Pending" },
        "": { badge: "orange_bdg", value: "Esign Pending" },
        PendingForEsign: { badge: "orange_bdg", value: "Esign Pending" },
        Approved: { badge: "orange_bdg", value: "Submit" },
        Processed: { badge: "green_bdg", value: "Closed" },
        "Rejected-EsignNotSubmitted": { badge: "red_bdg", value: "Rejected" },
        Rejected: { badge: "red_bdg", value: "Rejected" },
        EsignSubmitted: { badge: "orange_bdg", value: "Submit" },
        AssignedForEsignQC: { badge: "orange_bdg", value: "In Process" },
        PendingForProcessing: { badge: "orange_bdg", value: "In Process" },
        PushToTarget: { badge: "orange_bdg", value: "In Process" },
        EsignVerified: { badge: "orange_bdg", value: "In Process" },
        Submitted: { badge: "orange_bdg", value: "Pending" },
        QCPending: { badge: "orange_bdg", value: "Submit" },
    },
    _a[EServiceRequest.BANK] = {
        None: { badge: "orange_bdg", value: "Pending" },
        "": { badge: "orange_bdg", value: "Pending" },
        PendingForEsign: { badge: "orange_bdg", value: "Pending" },
        Processed: { badge: "green_bdg", value: "Completed" },
        "Rejected - EsignNotSubmitted": { badge: "red_bdg", value: "Rejected" },
        "Rejected - Autoexpired": { badge: "red_bdg", value: "Rejected" },
        "Rejected - Resubmit": { badge: "red_bdg", value: "Rejected" },
        Rejected: { badge: "red_bdg", value: "Rejected" },
        EsignSubmitted: { badge: "orange_bdg", value: "In Process" },
        AssignedForEsignQC: { badge: "orange_bdg", value: "In Process" },
        PendingForProcessing: { badge: "orange_bdg", value: "In Process" },
        PushToTarget: { badge: "orange_bdg", value: "In Process" },
        AssignedToHO: { badge: "orange_bdg", value: "In Process" },
        Resubmitted: { badge: "orange_bdg", value: "In Process" },
        Submitted: { badge: "orange_bdg", value: "Submit" },
        Approved: { badge: "orange_bdg", value: "Submit" },
        QCPending: { badge: "orange_bdg", value: "Submit" },
    },
    _a[EServiceRequest.ADDRESS] = {
        None: { badge: "orange_bdg", value: "Pending" },
        "": { badge: "orange_bdg", value: "Pending" },
        PendingForEsign: { badge: "orange_bdg", value: "Pending" },
        Processed: { badge: "green_bdg", value: "Completed" },
        "Rejected - EsignNotSubmitted": { badge: "red_bdg", value: "Rejected" },
        "Rejected - Autoexpired": { badge: "red_bdg", value: "Rejected" },
        "Rejected - Resubmit": { badge: "red_bdg", value: "Rejected" },
        Rejected: { badge: "red_bdg", value: "Rejected" },
        EsignSubmitted: { badge: "orange_bdg", value: "In Process" },
        AssignedForEsignQC: { badge: "orange_bdg", value: "In Process" },
        PendingForProcessing: { badge: "orange_bdg", value: "In Process" },
        PushToTarget: { badge: "orange_bdg", value: "In Process" },
        AssignedToHO: { badge: "orange_bdg", value: "In Process" },
        Resubmitted: { badge: "orange_bdg", value: "In Process" },
        Submitted: { badge: "orange_bdg", value: "Submit" },
        Approved: { badge: "orange_bdg", value: "Submit" },
        QCPending: { badge: "orange_bdg", value: "Submit" },
    },
    _a[EServiceRequest.CKYC] = {
        None: { badge: "orange_bdg", value: "Submit" },
        "": { badge: "orange_bdg", value: "Submit" },
        Approved: { badge: "orange_bdg", value: "Submit" },
        Processed: { badge: "green_bdg", value: "Completed" },
        "Rejected - Autoexpired": { badge: "red_bdg", value: "Rejected" },
        "Rejected - Resubmit": { badge: "red_bdg", value: "Rejected" },
        Rejected: { badge: "red_bdg", value: "Rejected" },
        Resubmitted: { badge: "orange_bdg", value: "In Process" },
        AssignedToHO: { badge: "orange_bdg", value: "In Process" },
        InProcess: { badge: "orange_bdg", value: "In Process" },
        Submitted: { badge: "orange_bdg", value: "Submit" },
        QCPending: { badge: "orange_bdg", value: "Submit" },
    },
    _a[EServiceRequest.FATCA] = {
        None: { badge: "orange_bdg", value: "Submit" },
        "": { badge: "orange_bdg", value: "Submit" },
        Processed: { badge: "green_bdg", value: "Completed" },
        Approved: { badge: "orange_bdg", value: "Submit" },
        PushToTarget: { badge: "orange_bdg", value: "In Process" },
        PendingForProcessing: { badge: "orange_bdg", value: "In Process" },
        Rejected: { badge: "red_bdg", value: "Rejected" },
        QCPending: { badge: "orange_bdg", value: "Submit" },
    },
    _a);
export var SRStatusDefaultMapping = {
    None: { badge: "orange_bdg", value: "Pending" },
    "": { badge: "orange_bdg", value: "Pending" },
    PendingForEsign: { badge: "orange_bdg", value: "Pending" },
    Processed: { badge: "green_bdg", value: "Completed" },
    "Rejected - EsignNotSubmitted": { badge: "red_bdg", value: "Rejected" },
    "Rejected - Autoexpired": { badge: "red_bdg", value: "Rejected" },
    "Rejected - Resubmit": { badge: "red_bdg", value: "Rejected" },
    Rejected: { badge: "red_bdg", value: "Rejected" },
    EsignSubmitted: { badge: "orange_bdg", value: "In Process" },
    AssignedForQC: { badge: "orange_bdg", value: "In Process" },
    AssignedForEsignQC: { badge: "orange_bdg", value: "In Process" },
    PendingForProcessing: { badge: "orange_bdg", value: "In Process" },
    PushToTarget: { badge: "orange_bdg", value: "In Process" },
    AssignedToHO: { badge: "orange_bdg", value: "In Process" },
    Resubmitted: { badge: "orange_bdg", value: "In Process" },
    Submitted: { badge: "orange_bdg", value: "Submit" },
    "Draft Saved": { badge: "orange_bdg", value: "Submit" },
    Approved: { badge: "orange_bdg", value: "Submit" },
    Delivered: { badge: "orange_bdg", value: "Delivered" },
    QCPending: { badge: "orange_bdg", value: "Submit" },
    // Add mappings for other RequestType values similarly
};
export var prefilledFormTypes = (_b = {},
    _b[EServiceRequest.BANK] = {
        redirectionName: "bank",
        downloadName: "BankPreFilledPDF",
    },
    _b[EServiceRequest.ADDRESS] = {
        redirectionName: "address",
        downloadName: "AddressPreFilledPDF",
    },
    _b[EServiceRequest.EMAILPHONE] = {
        redirectionName: "emailMob",
        downloadName: "Email&MobilePDF",
    },
    _b[EServiceRequest.REACTIVATION] = {
        redirectionName: "accReact",
        downloadName: "AccountReactivationPreFilledPDF",
    },
    _b[EServiceRequest.NOMINATION] = {
        redirectionName: "nomination",
        downloadName: "NomineePreFilledPDF",
    },
    _b[EServiceRequest.ACCOUNT_CLOSURE] = {
        redirectionName: "accClosure",
        downloadName: "Online Closure Request",
    },
    _b[EServiceRequest.DDPI] = {
        redirectionName: "ddpi",
        downloadName: "Online DDPI enablement",
    },
    _b);
export var SRRedirectionUrl = (_c = {},
    _c[EServiceRequest.BANK] = config.serviceRequest_base +
        config.sr_web +
        "service-request/bank-modification?source=onep-sr",
    _c[EServiceRequest.ADDRESS] = config.serviceRequest_base +
        config.sr_web +
        "service-request/address-modification?source=onep-sr",
    _c[EServiceRequest.EMAILPHONE] = config.serviceRequest_base +
        config.sr_web +
        "service-request/email-mobile-modification?source=onep-sr",
    _c[EServiceRequest.REACTIVATION] = config.serviceRequest_base +
        config.sr_web +
        "service-request/account-reactivation?source=onep-sr",
    _c[EServiceRequest.NOMINATION] = config.serviceRequest_base +
        config.sr_web +
        "service-request/nomination?source=onep-sr",
    _c[EServiceRequest.ACCOUNT_CLOSURE] = config.serviceRequest_base +
        config.sr_web +
        "service-request/account-closure?source=onep-sr",
    _c[EServiceRequest.DDPI] = config.serviceRequest_base +
        config.sr_web +
        "service-request/ddpi?source=onep-sr",
    _c[EServiceRequest.CKYC] = config.serviceRequest_base +
        config.sr_web +
        "service-request/ckyc-update?source=onep-sr",
    _c[EServiceRequest.FATCA] = config.serviceRequest_base +
        config.sr_web +
        "service-request/fatcaUpdate?source=onep-sr",
    _c[EServiceRequest.INCOME_DECLARATION] = config.serviceRequest_base +
        config.sr_lucidfox +
        "servicerequest?create-request&selectedVal=10&source=onep-sr",
    _c[EServiceRequest.DP_SCEHEME] = config.serviceRequest_base +
        config.sr_lucidfox +
        "servicerequest?create-request&selectedVal=8&source=onep-sr",
    _c[EServiceRequest.DIS_BOOKLET] = config.serviceRequest_base +
        config.sr_lucidfox +
        "servicerequest?create-request&selectedVal=7&source=onep-sr",
    _c[EServiceRequest.SMTF] = config.serviceRequest_base +
        config.sr_web +
        "service-request/smtf?source=onep-sr",
    _c[EServiceRequest.SEGMENT_ACTIVATION] = config.serviceRequest_base +
        config.sr_lucidfox +
        "servicerequest?create-request&selectedVal=9&source=onep-sr",
    _c);
